<div class="sorter-filter-cont">
  <app-box-filter
    [individualFilter]="individualFilter"
    [label]="label | transloco"
    [show]="isOpenBox"
    (toggleShow)="toggleCheckboxOptions()">
    <div class="sorter-list">
      <ng-container *ngFor="let sorter of sorters; index as i">
        <div class="radio">
          <app-ds-radio-button
            [checked]="isChecked(sorter.Label)"
            [align]="radioButtonAlign"
            [icon]="sorterIcon(sorter)"
            [title]="{ Label: sorter.Label | transloco }"
            (radioOnChecked)="select(sorter)">
          </app-ds-radio-button>
        </div>
      </ng-container>
    </div>
  </app-box-filter>
</div>